import type { FaireProductEntity } from "../../entity_types/product";

export const p_qa58efmccb: FaireProductEntity = {
  token: "p_qa58efmccb",
  type: "product",
  name: "Restore+ Magnesium Sleep Aid",
  brandToken: "b_w2k829fkq5",
  brandName: "SleepHabits",
  imageUrl:
    "https://cdn.faire.com/fastly/2160c0a681d94af682b58c0b75d042e8493718df0c62845ee8fbabdce0a2da5d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4640a60ddb35b59c7749b8bac0b7ffa55cc35a05fc18dcf7d4c8bca493dc05f5.jpeg",
    "https://cdn.faire.com/fastly/19249fdd834fec3874ef8bc14978ef543febbf05ed4acccbe593593877144e71.jpeg",
    "https://cdn.faire.com/fastly/5eaf25bebe41c937d77ea6498af49e0748128e5f12c76e6289c1b19f49d9b2d7.jpeg",
    "https://cdn.faire.com/fastly/c1fa1b8526e719c2beef68593085631933518d88fd5332936a1ab5984f022147.jpeg",
    "https://cdn.faire.com/fastly/287875fbf2cef2ac9aaaccfe1b62556806d68d5e6f18f06da833711cba942993.jpeg",
    "https://cdn.faire.com/fastly/5d8284e17ae8fd40cbb7ced85a5a813fcd3afa9cdf230394df870949dcd88800.png",
    "https://cdn.faire.com/fastly/db6719fed37577f433d3d2d5b1abc37cbd83c543acab2f630d7967f0f8434040.jpeg",
    "https://cdn.faire.com/fastly/3a7478154f71a1525fda0d6bac44af20af19731208d58de99f5b447df726bffc.jpeg",
  ],
  priceDollars: 28.6,
  description:
    "Relax. Rest. Recover.\n\nSleep Habits™ Restore+ is a melatonin-free magnesium wind-down drink designed to support your evening routine.\n\nRestore+ is the first natural sleep aid formula thoughtfully built around nitric oxide supporting ingredients. It is combined with magnesium, L-theanine, tart cherry, lemon balm, and glycine to help you ease into rest and regulate the body’s natural rhythm and deep sleep cycles.*\n\nThis calming drink is designed to promote healthy circulation and oxygen delivery while helping you unwind at night, so you can wake feeling refreshed in the morning and ready for the day ahead.\n\nCrafted with all natural / organic ingredients and without melatonin, Restore+ fits seamlessly into a consistent, habit-based approach to better sleep and recovery.\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:07.341Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
